<template>
  <div class="pin-entry-component">
    <div v-if="unlocked" class="countdown-container">
      <div class="radial">
        <div :class="`${animateClass} left rotate`">
          <span></span>
        </div>
        <div :class="`${animateClass} right rotate`">
          <span></span>
        </div>
      </div>
    </div>
    <div :class="`btn pin-entry-icon ${buttonClass}`" @click="handleLockClick">
      <span v-if="locked" class="material-icons">lock</span>
      <i v-else-if="unlocking" class="fas fa-key"></i>
      <span v-else-if="unlocked" class="material-icons">lock_open</span>
    </div>
    <div v-if="unlocking" class="pin-entry-input">
      <form @submit.prevent="handlePinSubmit">
        <input
          v-model="pin"
          ref="pinEntry"
          type="password"
          placeholder="Enter PIN"
          autocomplete="new-passwords"
          disabled
        >
      </form>
    </div>
    <PinEntryKeypad v-on:pin-input="handlePinInput($event)" v-if="unlocking"/>
  </div>
</template>

<script>
/* eslint-disable */
import { mapActions, mapState } from "vuex";
import { validatePin } from "../../services/endpoints";
import PinEntryKeypad from "./PinEntryKeypad";
import { constants } from "crypto";

const LOCKED = 1;
const PIN_ENTRY = 2;
const UNLOCKED = 3;

export default {
  components: {
    PinEntryKeypad
  },

  mounted() {
    this.lockedStatus = this.pinExists ? UNLOCKED : LOCKED;
  },

  data: () => ({
    lockedStatus: LOCKED,
    pin: null,
    animateClass: "circle",
    inputFocus: false
  }),

  computed: {
    ...mapState({
      pinExists: state => !!state.auth.pin,
      startPinCountDown: state => state.startPinCountDown
    }),

    locked() {
      return this.lockedStatus === LOCKED;
    },

    unlocking() {
      return this.lockedStatus === PIN_ENTRY;
    },

    unlocked() {
      return this.lockedStatus === UNLOCKED;
    },

    buttonClass() {
      switch (this.lockedStatus) {
        case LOCKED:
          return "--red";
        case UNLOCKED:
          return "--green unlocked";
        default:
          return "--blue";
      }
    }
  },

  methods: {
    ...mapActions(["setSuccessMessage", "setErrorMessage", "setPin"]),

    handlePinInput(input) {
      switch (input) {
        case "backspace":
          if (this.pin.length)
            this.pin = this.pin.slice(0, this.pin.length - 1);
          break;
        case "clear":
          this.pin = "";
          break;
        case "submit":
          this.handlePinSubmit();
          break;
        default:
          this.pin += input;
      }

      this.pin.length
      ? this.$refs.pinEntry.style.fontSize = '50px'
      : this.$refs.pinEntry.style.fontSize = '20px'

    },
    handlePinSubmit() {
      validatePin(this.pin)
        .then(resp => {
          this.setSuccessMessage("PIN validated");

          this.setPin(this.pin);
          this.lockedStatus = UNLOCKED;
          this.$emit("success", resp.data);
        })
        .catch(error => {
          this.$emit("fail", error);
        });
    },

    handleLockClick() {
      this.pin = "";
      if (this.lockedStatus === LOCKED) {
        this.lockedStatus = PIN_ENTRY;
        this.$nextTick(() => {
          this.$refs.pinEntry.focus();
          this.inputFocus = true;
        });
      }
    }
  },

  watch: {
    lockedStatus(status) {
      const val = s => {
        switch (s) {
          case LOCKED:
            return "locked";
          case UNLOCKED:
            return "unlocked";
          default:
            return "";
        }
      };

      this.$emit("statusChange", val(status));
    },

    startPinCountDown(start) {
      const toggleAnimationState = () => {
        this.animateClass = start ? "circle" : null;
      };

      this.$nextTick(toggleAnimationState);
    },

    pinExists(exists) {
      if (!exists) {
        this.lockedStatus = LOCKED;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.pin-entry-component {
  display: flex;
  border-radius: 37px;
  background: #fff;
  align-items: center;

  .pin-entry-icon {
    height: 100%;
    color: #fff;
    .material-icons,
    i {
      font-size: 26px;
    }
  }

  .pin-entry-input {
    width: 130px;
    border: none;
    padding: 0 10px;
    font-size: 20px;
    font-weight: bold;
    letter-spacing: -0.17px;
    line-height: 24px;

    input {
      width: 100%;
      border: none;
      padding-right: 20px;
      color: #000000;
      font-size: 20px;
      font-weight: bold;
      letter-spacing: -0.17px;
      line-height: 24px;
      outline: none;
    }
  }

  $countdownWidth: 78px;
  $countdownHeight: 78px;
  $countdownTime: 30s;

  .radial {
    position: relative;
    display: inline-block;
  }

  .countdown-container {
    position: absolute;
    top: -18px;
    left: -2px;
  }

  .circle.left {
    position: absolute;
    clip: rect(0, $countdownHeight, $countdownWidth, $countdownHeight / 2);
  }

  .circle.right {
    position: absolute;
    clip: rect(0px, $countdownHeight / 2, $countdownWidth, 0px);
  }

  .circle span {
    width: $countdownWidth;
    height: $countdownHeight;
    border-radius: 100%;
    position: absolute;
    border: 7px solid #ffe600;
  }

  .circle.left span {
    clip: rect(0px, $countdownHeight / 2, $countdownWidth, 0px);
    -webkit-animation: rotate-left $countdownTime infinite linear;
  }

  .circle.right span {
    clip: rect(0, $countdownHeight, $countdownWidth, $countdownHeight / 2);
    -webkit-animation: rotate-right $countdownTime infinite linear;
  }

  @-webkit-keyframes rotate-left {
    0% {
      -webkit-transform: rotate(0deg);
    }
    50% {
      -webkit-transform: rotate(180deg);
    }
    100% {
      -webkit-transform: rotate(180deg);
    }
  }

  @-webkit-keyframes rotate-right {
    0% {
      -webkit-transform: rotate(0deg);
    }
    50% {
      -webkit-transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(180deg);
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Booking/PinEntry.vue